export class PointTypesResponseDto {
  id: number;
  pointType: string;
  isActive: boolean;
  isExist?: boolean;

  constructor(
    id: number,
    pointType: string,
    isActive: boolean,
    isExist?: boolean
  ) {
    this.id = id;
    this.pointType = pointType;
    this.isActive = isActive;
    this.isExist = isExist;
  }
}
